import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { CalendarClock } from 'lucide-react';
import { API_BASE } from '../../config/api';
import { DUE_STYLES, formatDue } from '../../lib/activityTypes';

const API = `${API_BASE}/api`;

export default function UpcomingDeadlines({ token }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/learner/deadlines`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setItems((r.data.deadlines || []).filter((d) => !d.submission_status && !d.deadline.overdue)))
      .catch(() => setItems([]));
  }, [token]);
  if (!items.length) return null;
  return (
    <section className="rounded-2xl border border-amber-500/25 bg-zinc-900 p-5 mb-8" data-testid="upcoming-deadlines">
      <h2 className="text-white font-semibold flex items-center gap-2 mb-3"><CalendarClock className="h-4 w-4 text-amber-400" />Upcoming deadlines</h2>
      <ul className="divide-y divide-zinc-800">
        {items.slice(0, 6).map((d) => (
          <li key={d.activity_id}>
            <Link to={`/programmes/${d.programme_id}/assignments/${d.activity_id}`} className="flex flex-wrap items-center gap-3 py-3 group" data-testid={`deadline-${d.activity_id}`}>
              <span className="flex-1 min-w-[180px]">
                <span className="block text-sm text-white group-hover:text-teal-300 transition-colors">{d.title}</span>
                <span className="block text-xs text-zinc-500">{d.programme_name}</span>
              </span>
              <span className={`text-xs px-2.5 py-1 rounded-full border ${DUE_STYLES[d.deadline.state] || DUE_STYLES.open}`}>Due {formatDue(d.deadline.due_at)}</span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
